// extracted by mini-css-extract-plugin
module.exports = {"wrapperCard":"wrapperCard___8FP6J","wrapperImg":"wrapperImg___3X_i_","uploadFile":"uploadFile___1FdRZ","disableClick":"disableClick___1Q998"};